import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from '@/locales/en.json'

export const locales = ['en'] as const

export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = 'en'

export const initI18n = (): typeof i18next => {
  if (!i18next.isInitialized) {
    void i18next.use(initReactI18next).init({
      resources: {
        en: { translation: en },
      },
      lng: defaultLocale,
      fallbackLng: defaultLocale,
      supportedLngs: locales,
      interpolation: { escapeValue: false },
      returnNull: false,
    })
  }

  if (typeof document !== 'undefined') {
    document.documentElement.lang = defaultLocale
  }

  return i18next
}

export const currentLocale = (): Locale => defaultLocale
